import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const INPUT_VARIANTS = {
  DEFAULT: 'default',
  INVALID: 'invalid',
  VALID: 'valid',
  SECURE: 'secure',
  // TODO: not used yet
  ACTIVE: 'active',
  DISABLED: 'disabled',
};

const Input = props => {
  const { reference } = props;
  return <StyledInput {...props} ref={reference} />;
};

// TODO: use themes. Cant use now since Internals doesnt have one.
const THEMES = {
  [INPUT_VARIANTS.DEFAULT]: css`
    background-color: #ffffff;
    border-color: #d6d5c3;
    ::placeholder {
      color: #c2c5cc;
    }
  `,
  [INPUT_VARIANTS.SECURE]: css`
    background-color: #f2f2f2;
    border-color: #c2c5cc;
    ::placeholder {
      color: #c2c5cc;
    }
  `,
  [INPUT_VARIANTS.VALID]: css`
    background-color: #f2fae8;
    border-color: #d6d5c3;
  `,
  [INPUT_VARIANTS.INVALID]: css`
    background-color: #fffbe8;
    border-color: #f7aa1b;
    z-index: 2;
    border-right: 0;
    box-shadow: 1px 0 0 0 #f7aa1b; /* box shadow instead of border */
  `,
};

Input.VARIANTS = INPUT_VARIANTS;

export const StyledInput = styled.input`
  appearance: none; /* ios safari border fix */
  position: relative;
  border: 1px solid;
  border-radius: 4px;
  color: #17181a;
  font-weight: bold;
  padding: 14px 8px;
  font: inherit;

  ::placeholder {
    font-weight: normal;
  }

  ${props =>
    props.disabled &&
    `
    color: #919499;
  `}

  ${props => THEMES[props.variant]};
`;

Input.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onInput: PropTypes.func,
  placeholder: PropTypes.string,
  reference: PropTypes.any,
  type: PropTypes.string,
  value: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(INPUT_VARIANTS)),
};

Input.defaultProps = {
  autoFocus: false,
  className: '',
  disabled: false,
  onBlur: Function.prototype,
  onChange: Function.prototype,
  onClick: Function.prototype,
  onFocus: Function.prototype,
  onInput: Function.prototype,
  placeholder: '',
  reference: null,
  type: 'text',
  value: undefined,
  variant: INPUT_VARIANTS.DEFAULT,
};

export default Input;
